import React, { useState } from 'react';
import { useIntl } from "react-intl";
import { EntityCreate, EntityTypeLabel } from "@/model";
import { useCreateEntity } from "@/query/entity";
import { useAgentId, useModal } from "@/hook";
import Button from "@/component/Button";
import { Modal } from "@/component/modal";
import { TextInputGroup } from "@/component/input";
import { errorToast, successToast } from "@/component/Toast";


export const ENTITY_CREATE_MODAL_ID = "entity-create-modal-id";

const ENTITY_TYPE_OPTIONS: { id: EntityTypeLabel, label: string, describe: string }[] = [
    { id: 'normal', label: 'NORMAL ENTITY', describe: 'i05043' },
    { id: 'post', label: 'POST ENTITY', describe: 'i05044'  },
    { id: 'ignore', label: 'IGNORE ENTITY', describe: 'i05045'  },
];

const EntityAddModal: React.FC = () => {
    const intl = useIntl();
    const agentId = useAgentId();
    const modal = useModal();

    const [validated, setValidated] = useState<boolean>(false);
    const [name, setName] = useState<string>("");
    const [entityType, setEntityType] = useState<EntityTypeLabel>();

    const { mutateAsync: createEntity, isPending: isCreating } = useCreateEntity(agentId);

    const onClickConfirm = async () => {
        setValidated(true);
        const entityForm: EntityCreate = {
            agent_id: agentId,
            name: name.trim(),
            post_processing: entityType === "post",
            ignored: entityType === "ignore",
        };
        if (!entityForm.name) {
            return;
        }

        createEntity(entityForm)
            .then(() => {
                successToast(intl.formatMessage({ id: "t001" }));
                setValidated(false);
                modal.close(ENTITY_CREATE_MODAL_ID);
            })
            .catch(() => {
                errorToast(intl.formatMessage({ id: "t002" }));
            });
    };

    return (
        <Modal id={ENTITY_CREATE_MODAL_ID}
               size="md"
               title={intl.formatMessage({ id: "i05005" })}
               onClose={() => {
                   setName("");
                   setEntityType("normal");
                   setValidated(false);
               }}
        >
            <div className="modal-body-8">
                <div className="modal-description flex flex-col gap-6">
                    <TextInputGroup defaultValue=""
                                    invalid={validated && !name.trim()}
                                    label={intl.formatMessage({ id: "i05006" })}
                                    placeholder={intl.formatMessage({ id: "i05009" })}
                                    onChange={setName}
                    />
                    <div className="flex flex-col gap-1.5">
                        <div className="input-group-heading">
                            {intl.formatMessage({ id: "i05007" })}
                        </div>
                        <div className="flex flex-col gap-4">
                            {ENTITY_TYPE_OPTIONS.map(({ id, label, describe }) => (
                                <label key={id}
                                       className="flex gap-1 leading-none cursor-pointer"
                                >
                                    <input type="radio"
                                           name="select-entity-type"
                                           className="input-radio-chat42 size-3.5"
                                           checked={entityType === id}
                                           onChange={() => setEntityType(id)}
                                    />

                                    <div className="flex flex-col font-[400] leading-[1.5]">
                                        <div className="text-[13px] text-black-500">
                                            {label}
                                        </div>
                                        <div className="text-[12px] text-black-400">
                                            {intl.formatMessage({ id: describe })}
                                        </div>
                                    </div>
                                </label>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="modal-btn-group">
                    <Button size="sm"
                            variant="secondary"
                            disabled={isCreating}
                            onClick={() => modal.close(ENTITY_CREATE_MODAL_ID)}
                    >
                        {intl.formatMessage({ id: "b0002" })}
                    </Button>
                    <Button size="sm"
                            variant="primary"
                            disabled={isCreating}
                            onClick={onClickConfirm}
                    >
                        {intl.formatMessage({ id: "b0001" })}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default EntityAddModal;